import { Component, Input, OnDestroy } from '@angular/core';
import { RequestBuilderService } from '../../request-builder.service';
import { ActorActionEnum } from 'src/app/constants/actor-action.enum';
import { Subscription } from 'rxjs';
import { actionValidationSummary } from 'src/app/models/requests';

@Component({
  selector: 'app-action-table-all-documents',
  templateUrl: './action-table-all-documents.component.html'
})
export class ActionTableAllDocumentsComponent implements OnDestroy {

  @Input() allDocumentsActions?: any[] = [];

  private actionValidationRequest!: actionValidationSummary;
  public possibleActionsOnDocument: string[] = [];
  public blockedActionsOnDocument: string[] = []

  private requestSubscription: Subscription | null = null;

  constructor(private requestBuilderService: RequestBuilderService) {
    this.requestSubscription = this.requestBuilderService.validationSummary$.subscribe(validationSummary => {
      this.actionValidationRequest = validationSummary.actionValidationSummary;
    });
  }
  ngOnDestroy(): void {
    if (this.requestSubscription) {
      this.requestSubscription.unsubscribe();
    }
  }
  /**
   * Checks whether Request still allows more Actions
   * @returns 
   */
  allowedToAddMoreRequestActions() {
    return !this.actionValidationRequest?.request?.allowsMoreActions;
  }
  /**
   * Returns the ALL action options for the Request
   * make sure to DISABLE the blocked
   * @returns 
   */
  allRequestActionsFromSummary() {
    if (!this.actionValidationRequest || !this.actionValidationRequest?.request) {
      return [];
    }
    this.possibleActionsOnDocument = this.actionValidationRequest.request.possibleActions;
    this.blockedActionsOnDocument = this.actionValidationRequest.request.blockedActions;
    return this.possibleActionsOnDocument?.concat(this.blockedActionsOnDocument) ?? [];
  }
  /**
   * Verifies if the given Action is a BLOCKED action and returns TRUE if so, FALSE: not blocked
   * @param action 
   * @returns 
   */
  isActionDisabled(action: string): boolean {
    return this.actionValidationRequest.request.blockedActions.includes(<ActorActionEnum>action);
  }

  openAddActionDialog(desiredActionType: string) {
    this.requestBuilderService.openActionDialogWithoutDocumentId(<ActorActionEnum>desiredActionType);
  }


}
